// Единые состояния сетевых экранов: загрузка, ошибка, пусто.
import { Button } from '@astryxdesign/core/Button';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Skeleton } from '@astryxdesign/core/Skeleton';
import { Spinner } from '@astryxdesign/core/Spinner';
import { VStack } from '@astryxdesign/core/Stack';
import { Center } from '@astryxdesign/core/Center';
import { Icon } from '@astryxdesign/core/Icon';
import type { ReactNode } from 'react';
import { errorText } from '@/lib/errors';

export function PageLoader({ label = 'Загружаем' }: { label?: string }) {
  return (
    <Center minHeight="60dvh">
      <Spinner size="lg" label={label} />
    </Center>
  );
}

export function ListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <VStack gap={2} padding={4} aria-busy="true" aria-label="Загрузка">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} index={i} height={56} radius="rounded" />
      ))}
    </VStack>
  );
}

export function ErrorView({ error, onRetry, title = 'Не удалось загрузить' }: { error: unknown; onRetry?: () => void; title?: string }) {
  return (
    <Center minHeight="40dvh" padding={4}>
      <EmptyState
        icon={<Icon icon="warning" color="secondary" />}
        title={title}
        description={errorText(error)}
        actions={onRetry ? <Button label="Повторить" variant="primary" onClick={onRetry} /> : undefined}
      />
    </Center>
  );
}

export function EmptyView({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return (
    <Center minHeight="30dvh" padding={4}>
      <EmptyState isCompact title={title} description={description} actions={action} />
    </Center>
  );
}

export function NotFound() {
  return (
    <Center minHeight="100dvh" padding={4}>
      <EmptyState
        title="Страница не найдена"
        description="Проверьте адрес ссылки, которую прислала студия."
        icon={<Icon icon="search" color="secondary" />}
      />
    </Center>
  );
}

export function SetupRequired({ message }: { message: string }) {
  return (
    <Center minHeight="100dvh" padding={4}>
      <EmptyState title="Приложение не настроено" description={message} icon={<Icon icon="wrench" color="secondary" />} />
    </Center>
  );
}
